import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import PlanDiscount from "../../Components/PlanDiscount";
import { ScrollToPlans } from "../../utils/ScrollToPlan";

export default function Deals() {
  useEffect(() => {
        sal();
        }, []);
   const handlePlanClick = () => {
        ScrollToPlans(".deals-offer-section");
        };
  return (
    <>
        <Helmet>
            <title>Web Hosting & Server Offers | Best Deals on Hosting</title>
            <meta name="description" content="Explore the best web hosting and server offers with huge discounts on VPS, dedicated servers, and cloud hosting. Save more with Infinitive Host." />
            <meta name="keywords" content="Keywords - Web Hosting, Server, Special Offers, Discounts, Offers" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/deals`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/deals`} />
            <meta property="og:title" content="Web Hosting & Server Offers | Best Deals on Hosting" />
            <meta property="og:description" content="We offer the best web hosting services that redefine your online experience at affordable prices. Get fast SSD NVMe storage, Free migration, and 24/7 support." />
        </Helmet>

        <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
          <div className="container">
              <div className="row g-4 align-items-center align-items-xxl-end">
                  <div className="col-xl-7">
                      <div className="d-flex align-items-center gap-2">
                          <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                          <span className="d-block fw-semibold mb-0 text-primary">
                              Click. Launch. Save. The Best Way to Host.
                          </span>
                      </div>
                      <h1 className="mb-6 text-white">
                          Oops! You Just Caught Us Giving Up to 75% OFF on All Plans
                      </h1>
                      <ul className="mb-8 text-white text-opacity-75">
                        <li>No Downtime Issue</li>
                        <li>Free Website Shift</li>
                        <li>Help on Speed Dial</li>
                      </ul>
                      <div className="d-flex align-items-center flex-wrap gap-4 pb-3">
                          <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded">
                              <span className="btn-arrow__text">
                                  Free Trial
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </Link>
                      </div>
                  </div>
                  <div className="col-xl-5">
                      <div className="about-banner__img">
                          <img src="images/about-banner-img.png" alt="image" className="img-fluid" />
                      </div>
                  </div>
              </div>
          </div>
        </div>

        <div className="container pt-100">
            <div className="row">
                <div className="col-12">
                    <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="row g-4 align-items-center">
                        <div className="col-lg-6">
                            <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-xxl-8 feature-card__list m-auto">
                                <div className="feature-card__is rounded-3">
                                    <div className="mb-4">
                                        <img src="images/service_16_card_1.png" alt="image" className="img-fluid" />
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-6 col-xl-5">
                                <h2 className="text-white">
                                    Finally, VPS Hosting That Never Lets You Down
                                </h2>
                                <p className="mb-8 text-white text-opacity-75">
                                    You won’t notice it until everything runs smoothly. That’s the main strength of our VPS hosting plans: quiet, fast, and always operational. No specific limits. No more lag.
                                </p>
                                <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-4 m-auto">
                                <span className="d-inline-block me-1 flex-shrink-0">
                                    <i className="las la-comments"></i>
                                </span>
                                <span className="btn-arrow__text">+91-7737300013
                                    <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                                </Link>
                                <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 m-auto mt-sm-0 mt-4 open-live-chat">
                                <span className="d-inline-block me-1 flex-shrink-0">
                                    <i className="las la-comments"></i>
                                </span>
                                <span className="btn-arrow__text">Talk to an Expert
                                    <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                                </Link>
                            </div>
                        </div>
                        <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                    </div>
                </div>
            </div>
        </div>

        <PlanDiscount/>

        <div className="why-choose-section pt-100 pb-100">
            <div className="pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-lg-8 col-xl-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <span className="d-flex align-items-center gap-2 mb-3">
                    <span className="d-block w-2 h-2 rounded-circle bg-success"></span>
                            <span className="d-block text-white">
                    <span className="text-success">WordPress Hosting</span> Up To 75% OFF
                            </span>
                            </span>
                            <h2 className="mb-0 text-white">
                                Support’s Just a Click or Call Away (Even at 2 AM)
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 col-xxl-7">
                        <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <img src="/images/partner-1.png" alt="image" className="img-fluid"/>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-5 col-xxl-4">
                        <ul className="list-unstyled vstack gap-4">
                            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                <div className="cloud-card">
                                    <h6 className="cloud-card__title mb-4">Stuck? Contact us anytime-real humans, no bots.</h6>
                                </div>
                            </li>
                            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                <div className="cloud-card">
                                    <h6 className="cloud-card__title mb-4">Love DIY? Follow our step-by-step guides that really make sense.</h6>
                                </div>
                            </li>
                            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                <div className="cloud-card">
                                    <h6 className="cloud-card__title mb-4">Wanna upgrade? Check out tutorials that turn you into a site boss.</h6>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <section className="pt-100 pb-100">
            <div className="container">
                <div className="bg-white px-8 py-10 rounded-3">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-5">
                            <img src="/images/setp-img-1.png" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                        </div>
                        <div className="col-lg-7">
                            <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                                    <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Get Everything In Your Budget.
                                </small>
                            </div>
                            <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Sick of Slow Load, Support That Ghosts, or Random Crashes?</h2>
                            <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> Don’t worry! Just slide your website over to us-smooth, hassle-free, and zero downtime issues. Our team manages it all (for FREE), while you stay focused on what matters: your business. No drama. No data loss. Just true support.</p>
                            <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate mt-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <span className="btn-arrow__text">
                                        Get Started
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}
